import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { postNewsletter } from '@/lib/api';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      setStatus('loading');
      await postNewsletter(email);
      setStatus('done');
      setEmail('');
    } catch (err) {
      setStatus('error');
    }
  };
  return (
    <footer className="border-t py-12 xl:py-16 border-[#1a1a1a] bg-[#0e0e0e] hero-grid" data-testid="site-footer">
      <div className="container-r360">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 xl:gap-12">
          <div>
            <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
              <img src={`${process.env.PUBLIC_URL}/img/main-logo.png`}  alt="Retarget360.ai logo"
                        className="h-10 w-auto" />
              </Link>
            <p className="text-[14px] leading-relaxed max-w-xs mt-4">
              The only enterprise retargeting platform that charges you nothing until a verified sale occurs.
            </p>
            <div className="mt-6 xl:mt-8">
              <div className="font-bold mb-3">Get The Monthly Intelligence Brief</div>
              <form onSubmit={submit} className="flex items-end gap-3 max-w-sm">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="work@yourcompany.com"
                  className="field-input flex-1"
                  data-testid="footer-newsletter-input"
                />
                <button
                  type="submit"
                  className="bg-[#60a5fa] hover:bg-[#00e0ff] px-5 py-3 text-[#0e0e0e] font-black"
                  data-testid="footer-newsletter-submit"
                  aria-label="Subscribe"
                >
                  →
                </button>
              </form>
              {status === 'done' && <div className="text-[#22d07a] text-xs mt-2 font-mono">✓ SUBSCRIBED</div>}
              {status === 'error' && <div className="text-red-500 text-xs mt-2 font-mono">✗ TRY AGAIN</div>}
            </div>
          </div>

          <div>
            <div className="font-extrabold font-display text-[#60a5fa] mb-6">PLATFORM</div>
            <ul className="space-y-3 text-[15px]">
              <li><a href="/#pipeline" className="font-medium hover:text-[#00e0ff] transition-colors">AI Pipeline</a></li>
              <li><a href="/#tech-stack" className="font-medium hover:text-[#00e0ff] transition-colors">Tech Stack</a></li>
              <li><Link to="/pricing" className="font-medium hover:text-[#00e0ff] transition-colors">Pricing</Link></li>
              <li><Link to="/calculator" className="font-medium hover:text-[#00e0ff] transition-colors">ROAS Calculator</Link></li>
            </ul>
          </div>

          <div>
            <div className="font-extrabold font-display text-[#60a5fa] mb-6">COMPANY</div>
            <ul className="space-y-3 text-[15px]">
              <li><Link to="/case-studies" className="font-medium hover:text-[#00e0ff] transition-colors">Case Studies</Link></li>
              <li><Link to="/book-a-demo" className="font-medium hover:text-[#00e0ff] transition-colors">Book a Demo</Link></li>
              <li><a href="mailto:partners@retarget360.ai" className="font-medium hover:text-[#00e0ff] transition-colors">Contact</a></li>
              <li><Link to="/admin" className="font-medium hover:text-[#00e0ff] transition-colors">Admin</Link></li>
            </ul>
          </div>

          <div>
            <div className="font-extrabold font-display text-[#60a5fa] mb-6">DIRECT LINE</div>
            <a href="mailto:partners@retarget360.ai" className="block font-medium text-[15px] hover:text-[#00e0ff] transition-colors">
              partners@retarget360.ai
            </a>
            {/* <div className="text-[15px] text-[#c9c9c9] mt-2">+1 (800) R360-WIN</div> */}
            <div className="font-extrabold font-display text-[#60a5fa] mb-6 mt-8">COMPLIANCE</div>
            <div className="font-medium text-[13px]">GDPR · CCPA · SOC 2 Type II</div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between mt-12 xl:mt-16 pt-8 border-t border-[#8a8a8a] gap-2">
          <div className="font-medium text-[14px]">&copy; {new Date().getFullYear()} Retarget360.AI | All Rights Reserved.</div>
          <div className="font-medium  text-[14px]">Built For Enterprises That Measure Everything.</div>
        </div>
      </div>
    </footer>
  );
}
